const COMMON_COUNTRY_CODES: Record<string, string> = {
	"united kingdom": "GB",
	uk: "GB",
	britain: "GB",
	england: "GB",
	"united states": "US",
	"united states of america": "US",
	usa: "US",
	france: "FR",
};

export function normalizeCountryCode(value?: string | null): string {
	const code = value?.trim().toUpperCase();
	return code && /^[A-Z]{2}$/.test(code) ? code : "";
}

export function countryNameToCode(country?: string | null): string {
	const raw = country?.trim();
	if (!raw) return "";

	const direct = normalizeCountryCode(raw);
	if (direct) return direct;

	const normalized = raw.toLowerCase();
	if (COMMON_COUNTRY_CODES[normalized]) {
		return COMMON_COUNTRY_CODES[normalized];
	}

	try {
		const supportedValuesOf = (Intl as any).supportedValuesOf;
		if (typeof supportedValuesOf !== "function") return "";

		const displayNames = new Intl.DisplayNames(["en"], { type: "region" });
		for (const code of supportedValuesOf("region") as string[]) {
			if (displayNames.of(code)?.toLowerCase() === normalized) {
				return code.toUpperCase();
			}
		}
	} catch {
		return "";
	}

	return "";
}

export function reviewCountryCode(review: {
	countryCode?: string | null;
	userId?: { country?: string | null } | null;
}): string {
	return normalizeCountryCode(review.countryCode) || countryNameToCode(review.userId?.country) || "GB";
}
